import qql from "graphql-tag";

export const editWebsiteTemplate = qql`
mutation editWebsiteTemplate($websiteTemplate: AWSJSON, $shopId: String) {
  editWebsiteTemplate(websiteTemplate: $websiteTemplate, shopId: $shopId) {
    userId
  }
}
`;
